<template>
  <div class="mt-2">
    <v-tabs
      v-model="tab"
      class="custom-tab-tutor"
    >
      <v-tab
        v-for="item in items"
        :key="item.key"
        :value="item.key"
        class="custom-tab-tutor-sub"
      >
        <span class="px-2" style="font-size: 12px;">{{ item.text }} <span style="background-color:#F89234" class="count mx-2">{{ totalContactModule }}</span></span>
      </v-tab>
      <v-tab-item>
        <StudentHighCare :filterForm="filterForm" :filterFormChange="filterFormChange" :priorityConfig="priorityConfig" />
      </v-tab-item>
      <v-tab-item></v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import StudentHighCare from './student_care/StudentHighCare.vue';

export default {
  components: {
    StudentHighCare,
  },
  props: {
    filterForm: {
      type: Object,
      default: () => {
      },
    },
    filterFormChange: {
      type: Object,
      default: () => {},
    },
    priorityConfig: {
      type: Number,
      required: true,
    },
  },
  mounted() {
    this.getListCallType({
      'filters[$eq__typeCustomerCare]': this.filterForm.typeCustomerCare,
      'filters[$eq__type_curriculum]': this.filterForm.type_curriculum,
    });
  },
  computed: {
    ...mapState('blended', ['countStatusModuleList', 'totalContactModule', 'typeHeaderStatusModule', 'dataBlendedTutor']),
  },
  methods: {
    ...mapActions('student_care', ['getListProgram', 'getListCallType']),
  },
  data() {
    return {
      tab: 'studentCare',
      items: [{ key: 'studentCare', text: 'Học sinh cần chăm sóc đặc biệt ' }],
    };
  },
};
</script>
<style lang="scss" scoped>
.count {
  border-radius: 70%;
  padding: 2px 4px;
  color: #f9f9f9;
  min-width: 32px;
}
</style>
<style lang="scss">
.custom-tab-tutor {
  .theme--light {
    background-color: #F4F5FA;
    &.v-btn {
      background-color: transparent !important;
    }
    &.v-tabs-bar {
      background-color: transparent !important;
    }
  }
  .v-tabs-items {
    background-color: #fff !important;
  }
  .v-tabs-slider-wrapper {
    height: 0px !important;
  }
  .custom-tab-tutor-sub {
    border-top-right-radius: 7px ;
    border-top-left-radius: 7px ;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    &.v-tab {
      background: #EFEFEF;
      color: #B2AEA6
    }
    &.v-tab--active {
      color: #F89234 !important;
      border-top: 4px solid #F89234 !important;
      margin: 0px 9px !important;
      background: #FFF;
    }
  }
}
</style>
